/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:28
 * @LastEditTime: 2019-07-24 14:47:37
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  普通仓库供给管理接口Url
const websiteIndexSupplyUrl = '/website/index/storage/storageSupply'

//  普通仓库供给管理接口Url
const websiteSupplyUrl = '/website/storage/supply'

// 分页查询仓库供给列表
export function findPageSupply(param, userType) {
  const supplyUrl = userType == '' ? websiteIndexSupplyUrl : websiteSupplyUrl
  return logistice({
    url: LOGISTICE_GATEWAY + supplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageSupply'
      }, param))
    }
  })
}
